import testStepApi from "../api/testStep";

const actions = {
  async createTestStep({ commit, state }, { releaseNoteId }) {
    await testStepApi.createTestStep(releaseNoteId, state.testStepRecord);
    const testStepList = await testStepApi.list(releaseNoteId);
    commit("resetTestStepRecord");
    return commit("setList", { releaseNoteId, testSteps: testStepList.data.result });
  },
  async delete({ commit }, { releaseNoteId, shiftTestSteps, testStepId }) {
    await testStepApi.deleteTestStep(testStepId, shiftTestSteps);
    const testStepList = await testStepApi.list(releaseNoteId);
    return commit("setList", { releaseNoteId, testSteps: testStepList.data.result });
  },
  async list({ commit }, { releaseNoteId }) {
    commit("setTestStepLoader", true);

    try {
      const testStepList = await testStepApi.list(releaseNoteId);
      return commit("setList", { releaseNoteId, testSteps: testStepList.data.result });
    } finally {
      commit("setTestStepLoader", false);
    }
  },
  async memberList({ commit }, { releaseNoteId, serviceAreaId }) {
    const memberTestStepList = await testStepApi.memberList(releaseNoteId, serviceAreaId);
    return commit("setMemberList", { releaseNoteId, testSteps: memberTestStepList.data.result });
  },
  async memberTestStep({ commit, state }, { releaseNoteId, serviceAreaId, testStepId }) {
    // Cache by releaseNoteId only - members stay within their service area for the session,
    // so we don't need to include serviceAreaId in the cache key
    if (!state.memberTestStepsByReleaseNote[releaseNoteId]) {
      const memberTestStepList = await testStepApi.memberList(releaseNoteId, serviceAreaId);
      commit("setMemberList", { releaseNoteId, testSteps: memberTestStepList.data.result });
    }

    const memberStep = (state.memberTestStepsByReleaseNote[releaseNoteId] || []).find(
      step => step.testPlanStepId === testStepId
    );

    if (!memberStep) {
      console.error(
        `Member test step ${testStepId} not found for releaseNoteId ${releaseNoteId}, serviceAreaId ${serviceAreaId}`
      );
      return;
    }

    commit("setMemberTestStepRecord", memberStep);
  },
  resetTestStepRecord({ commit }) {
    commit("resetTestStepRecord");
  },
  async getTestStep({ commit }, { testStepId }) {
    const testStep = await testStepApi.getTestStep(testStepId);
    return commit("setTestStepRecord", testStep.data.result);
  },
  async updateMemberStep(_context, data) {
    return testStepApi.updateMemberStep(data);
  },
  async updateTestStep({ commit }, { data, releaseNoteId }) {
    const update = await testStepApi.updateTestStep(data);
    commit("setTestStepRecord", update.data.result);
    //TODO: Should we do this on the component side? Seems like it pollutes the action by calling more than one action when we refresh the list
    const testStepList = await testStepApi.list(releaseNoteId);
    return commit("setList", { releaseNoteId, testSteps: testStepList.data.result });
  },
};

const mutations = {
  setList(state, { releaseNoteId, testSteps }) {
    state.testStepsByReleaseNote = {
      ...state.testStepsByReleaseNote,
      [releaseNoteId]: testSteps,
    };
  },
  setMemberList(state, { releaseNoteId, testSteps }) {
    state.memberTestStepsByReleaseNote = {
      ...state.memberTestStepsByReleaseNote,
      [releaseNoteId]: testSteps,
    };
  },
  setMemberTestStepRecord(state, record) {
    state.memberTestStepRecord = Object.assign({}, record);
  },
  setTestStepLoader(state, isLoading) {
    state.isLoadingTestStepList = isLoading;
  },
  setTestStepRecord(state, record) {
    state.testStepRecord = Object.assign({}, record);
  },
  resetTestStepRecord(state) {
    state.testStepRecord = {};
  },
};

const state = {
  isLoadingTestStepList: false,
  // Context-scoped lists (eliminates race conditions)
  testStepsByReleaseNote: {}, // { 1: [...], 2: [...] }
  memberTestStepsByReleaseNote: {}, // { 1: [...], 2: [...] }
  // Working records for forms (create/edit)
  testStepRecord: {},
  memberTestStepRecord: {},
};

const getters = {
  // Get test steps for a specific release note
  testStepList: state => releaseNoteId => {
    return state.testStepsByReleaseNote[releaseNoteId] || [];
  },

  // Get member test steps for a specific release note
  memberTestStepList: state => releaseNoteId => {
    return state.memberTestStepsByReleaseNote[releaseNoteId] || [];
  },
};

export default {
  actions,
  getters,
  mutations,
  namespaced: true,
  state,
};
